import { useEffect, useRef } from 'react';

export const WAREHOUSE_TASK_COUNT_UPDATED_EVENT = 'warehouse_task_count_updated';
export type WarehouseTaskCountUpdatedEventDetail = { count: number };

type DocumentEventListenerCallback<T> = (detail: T) => void;

export const useDocumentEventListener = <T>(type: string, callback: DocumentEventListenerCallback<T>) => {
  const ref = useRef<DocumentEventListenerCallback<T>>(callback);

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  useEffect(() => {
    const trigger = (event: CustomEvent<T>) => {
      ref.current(event.detail);
    };

    document.addEventListener(type, trigger as EventListener);
    return () => {
      document.removeEventListener(type, trigger as EventListener);
    };
  }, [type]);
};

export const dispatchDocumentEvent = <T>(type: string, detail: T) => {
  const event = new CustomEvent<T>(type, { detail });
  document.dispatchEvent(event);
};
